// Portfolio content for Satyam Garhewal — sourced from his AI resume.
export const PROFILE = {
  name: "Satyam Garhewal",
  role: "AI Engineer",
  tagline:
    "Building AI microservices, generative-AI products and scalable applications for ambitious teams.",
  location: "Pune, India",
  phone: "+91-9131369393",
  email: "garhewalsatyam996@gmail.com",
  linkedin: "https://www.linkedin.com/in/satyam-garhewal-711357152/",
  github: "https://github.com/Satyamgarhewal",
  medium: "https://medium.com/@Satyam_Garhewal",
  yearsExperience: "7+",
  available: "Open to senior AI / full-stack roles & freelance",
  bio: [
    "I'm a software engineer with deep experience building AI microservices, generative AI products and scalable applications. I specialise in high-availability solutions that optimise resource usage and enhance data-processing pipelines.",
    "Currently AI & Development Solutions Manager at EXL Services, leading work on the Smart Agent Assist (SAA) platform — building the product and helping enterprise customers integrate SAA into their customer-support stack. Previously shipped generative AI at Brillio, personalisation at Firstcry and scaled ZEE5's frontend at Valtech.",
  ],
};

export const SKILLS = [
  {
    label: "Languages",
    items: ["JavaScript", "TypeScript", "Python", "SQL"],
  },
  {
    label: "Frontend",
    items: [
      "React",
      "Redux",
      "Next.js",
      "React Native",
      "HTML",
      "CSS",
      "Material UI",
      "Tailwind",
    ],
  },
  {
    label: "Backend",
    items: ["Node.js", "FastAPI", "Nest.js", "Express.js", "Flask", "Django"],
  },
  {
    label: "Frameworks",
    items: ["Redis", "Serverless", "Sequelize", "AWS"],
  },
  {
    label: "Gen AI",
    items: [
      "LLMs",
      "RAG",
      "AI Agents",
      "LangChain",
      "Langgraph",
      "Hugging Face",
    ],
  },
  {
    label: "AI / ML",
    items: ["Pandas", "NumPy", "Matplotlib", "Pytorch", "Keras", "TensorFlow"],
  },
];

export const EXPERIENCE = [
  {
    company: "EXL Services",
    role: "AI & Development Solutions Manager",
    location: "India",
    period: "Present",
    current: true,
    summary:
      "Leading product engineering on Smart Agent Assist (SAA) — building the platform and helping enterprises integrate it into their customer-support stack. Also driving the AWS architecture for backend services and cloud tooling.",
    bullets: [
      "Driving end-to-end product engineering on Smart Agent Assist (SAA) — a real-time AI co-pilot that surfaces context, next-best actions and knowledge-base answers to live customer-support agents.",
      "Partner with enterprise clients to integrate SAA into their existing support stacks (telephony, CRM, ticketing) and tune the AI for each domain.",
      "Acting as AWS Architect on the project — designing scalable backend services, event-driven cloud tooling and secure data pipelines on AWS (Lambda, API Gateway, S3, EventBridge).",
      "Architecting LLM-powered pipelines: live transcription, intent detection, retrieval-augmented prompts and response summarisation to cut agent handle time.",
      "Owning the CI/CD, observability and cost-optimisation story for the platform — Infrastructure-as-Code, automated rollouts and SLO-driven monitoring.",
      "Leading a cross-functional pod of AI, backend and frontend engineers; setting technical direction, code-review standards and release cadence.",
    ],
    stack: [
      "AI Engineering",
      "LLMs",
      "RAG",
      "Python",
      "FastAPI",
      "AWS",
      "Lambda",
      "API Gateway",
      "AWS Architect",
    ],
  },
  {
    company: "Brillio Technologies",
    role: "Sr. Software Engineer",
    location: "Pune, India",
    period: "05/2022 — Prior",
    current: false,
    summary:
      "Building generative AI and full-stack systems for enterprise clients — primarily Sempra's energy management platform.",
    bullets: [
      "Delivered 3 mission-critical full-stack (React + Python) and AI solutions for Sempra, ensuring 100% business continuity for large-scale energy management systems.",
      "Architected and deployed serverless AI microservices using Python, FastAPI, AWS Lambda and API Gateway — achieving ~99.99% uptime while cutting infrastructure maintenance cost.",
      "Built scalable AI-powered REST APIs for real-time data processing and integration with ML pipelines, and shipped responsive React dashboards to visualise insights.",
      "Developed an LLM-powered conversational AI chatbot using RAG with LangChain and HuggingFace models, integrated into a React frontend for real-time user engagement.",
      "Designed AI agents to analyse customer gas-usage patterns and generate personalised recommendations, surfaced via interactive React UI components.",
      "Implemented document & knowledge retrieval pipelines using embeddings and vector search to improve response relevance and reduce LLM hallucinations.",
    ],
    stack: [
      "Python",
      "FastAPI",
      "AWS Lambda",
      "API Gateway",
      "React",
      "LangChain",
      "HuggingFace",
      "LLMs",
      "RAG",
    ],
  },
  {
    company: "Firstcry.com",
    role: "Software Engineer",
    location: "Pune, India",
    period: "03/2021 — 04/2022",
    current: false,
    summary:
      "Shipped full-stack platform features and personalisation systems for India's leading kids & baby commerce platform.",
    bullets: [
      "Developed full-stack applications using Angular, Node.js and Express, deployed on AWS and Google Cloud — accelerating feature delivery and cross-platform reliability.",
      "Built JARVIS, an intelligent activity-tracking system across FirstCry's web and mobile apps that analysed user behaviour and powered personalised offer recommendations — lifted engagement by 20% and boosted conversion rates.",
      "Designed and executed RESTful APIs using Express.js, reducing data-retrieval time and improving backend response efficiency.",
      "Built and integrated Node.js microservices, measurably improving application performance and reducing server load by optimising resource usage.",
      "Automated cron jobs and crafted complex queries for Big Data processing — enabling real-time analytics and sharper campaign targeting.",
    ],
    stack: ["Angular", "Node.js", "Express", "AWS", "Google Cloud", "Big Data"],
  },
  {
    company: "Valtech",
    role: "Associate Software Developer",
    location: "Bangalore, India",
    period: "03/2019 — 03/2021",
    current: false,
    summary:
      "Frontend & backend engineering on ZEE5 — one of India's largest OTT platforms.",
    bullets: [
      "Supported front-end development for ZEE5, facilitating seamless experiences for over 100M monthly active users.",
      "Used React.js to enhance the front-end framework — a 20% improvement in page responsiveness and overall user experience.",
      "Designed and developed a Progressive Web App (PWA) for ZEE5 — improving mobile accessibility and driving a 15% increase in repeat visits from mobile users.",
      "Built backend features including user authentication, content management and video streaming workflows, with smooth integration with third-party services & APIs.",
    ],
    stack: ["React.js", "JavaScript", "PWA", "Node.js"],
  },
];

export const PROJECTS = [
  {
    id: "alpha-watch",
    title: "Alpha Watch — AI Stock Analysis Agent",
    kicker: "Personal · AI Agents",
    blurb:
      "An AI-powered stock analysis platform that fuses technical indicators, financial fundamentals and market sentiment. Data pipelines ingest prices, financials and news; ML + LLM-based summarisation extract signals; AI agents generate investment insights and risk flags via a FastAPI backend and interactive React dashboard.",
    stack: ["Python", "FastAPI", "React", "LLMs", "AI Agents"],
    image:
      "https://images.unsplash.com/photo-1526289034009-0240ddb68ce3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwxfHxkYXJrJTIwbW9kZXJuJTIwYXJjaGl0ZWN0dXJlJTIwZ2VvbWV0cmljfGVufDB8fHx8MTc4MDk4NTgwNHww&ixlib=rb-4.1.0&q=85",
    span: "lg:col-span-7",
  },
  {
    id: "flight-fare",
    title: "Flight Fare Prediction",
    kicker: "Machine Learning · Personal",
    blurb:
      "Trained a regression model on historical flight pricing data with engineered features for route, seasonality and lead time — reached ~89% accuracy using XGBoost.",
    stack: [
      "Python",
      "Pandas",
      "NumPy",
      "Scikit-learn",
      "XGBoost",
      "Matplotlib",
      "Seaborn",
    ],
    image: null,
    span: "lg:col-span-5",
  },
  {
    id: "sempra-ai",
    title: "Sempra AI Microservices",
    kicker: "Generative AI · Brillio",
    blurb:
      "Three mission-critical full-stack + AI solutions for Sempra's energy management platform. Serverless AI microservices on AWS Lambda + API Gateway delivering ~99.99% uptime while cutting infra cost, with React dashboards surfacing real-time ML insights.",
    stack: ["Python", "FastAPI", "AWS Lambda", "API Gateway", "React"],
    image:
      "https://images.unsplash.com/photo-1518773553398-650c184e0bb3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHxtaW5pbWFsaXN0JTIwZGFyayUyMHRlY2hub2xvZ3klMjBjb2RlJTIwYmFja2dyb3VuZHxlbnwwfHx8fDE3ODA5ODU4MDR8MA&ixlib=rb-4.1.0&q=85",
    span: "lg:col-span-8",
  },
  {
    id: "llm-chatbot",
    title: "LLM Conversational AI Chatbot (RAG)",
    kicker: "Generative AI · Brillio",
    blurb:
      "LLM-powered chatbot built with RAG, LangChain and HuggingFace models. Document & knowledge retrieval pipelines using embeddings and vector search to improve response relevance and reduce hallucinations — integrated into a React frontend for real-time engagement.",
    stack: [
      "LangChain",
      "HuggingFace",
      "RAG",
      "Python",
      "React",
      "Vector Search",
    ],
    image: null,
    span: "lg:col-span-4",
  },
  {
    id: "jarvis",
    title: "JARVIS — Personalisation Engine",
    kicker: "Personalisation · Firstcry",
    blurb:
      "An intelligent activity-tracking system across Firstcry's web and mobile apps. Analysed user behaviour to power personalised offer recommendations — lifted engagement by 20% and boosted conversion.",
    stack: ["Angular", "Node.js", "Express", "AWS", "Google Cloud"],
    image: null,
    span: "lg:col-span-6",
  },
  {
    id: "zee5-pwa",
    title: "ZEE5 Progressive Web App",
    kicker: "Frontend · Valtech",
    blurb:
      "Designed and developed a PWA for ZEE5 — one of India's largest OTT platforms with 100M+ MAUs. Drove a 15% increase in repeat mobile visits and 20% improvement in page responsiveness.",
    stack: ["React.js", "JavaScript", "PWA"],
    image:
      "https://images.unsplash.com/photo-1758073519996-6d3c63b4922c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwyfHxkYXJrJTIwYWJzdHJhY3QlMjBuZXVyYWwlMjBuZXR3b3JrJTIwdGVjaHxlbnwwfHx8fDE3ODA5ODU4MDV8MA&ixlib=rb-4.1.0&q=85",
    span: "lg:col-span-6",
  },
];

export const EDUCATION = [
  {
    degree: "B.Tech, Computer Science and Technology",
    institution: "Sagar Institute of Research and Technology",
    location: "Bhopal, India",
    period: "Graduated 06/2018",
  },
];

export const CERTIFICATIONS = [
  { title: "Data Science Certification", issuer: "IIT Roorkee" },
  { title: "AWS Developer Certification", issuer: "AWS Cloud" },
  { title: "AZ-900 Certification", issuer: "Microsoft Azure" },
  { title: "AI Agents Certification", issuer: "Scrimba" },
];
